module.exports = __webpack_public_path__ + "static/media/tab-intelligent-text.5097cb73.png";